import React, { useContext, useState } from 'react'
import { CONFIG } from './config'
import styled from 'styled-components'
import { Waypoint } from 'react-waypoint'
import InfoBoard from '../InfoBoard'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import GlobalContext from 'Contexts/GlobalContext'

const MAX_SCROLL_INDEX = 3
/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  defaultDistance = CONFIG.default.spacerHeight,
  className,
}: {
  front: JSX.Element[]
  back: (e: number, o: { [key: string]: any }) => JSX.Element
  defaultDistance?: number
  className?: string
}) => {
  // use globalcontext
  const { scrollIndex, setScrollIndex } =
  useContext(GlobalContext)
console.log("render Scroller with index", scrollIndex);
  return (
    <StyledScroller className={'Scroller ' + className} id='scroller'>
      <div className='back' id='back'>
        {back(scrollIndex, front[scrollIndex])}
      </div>
      {/* <Spacer style={{ minHeight: defaultDistance + 'px' }} /> */}

      <div className='front'>
        {front.map((element, i) => {
          let dbottom = element.props.distanceBottom || defaultDistance || 1
          let dtop = element.props.distanceTop || defaultDistance || 1
          return (
            <React.Fragment key={'Front_' + i}>
              {(i>0) && <Spacer style={{ minHeight: dtop + 'px' }} />}

              <Waypoint
                scrollableAncestor={window}
                onEnter={() => {
                  const newIndex = Math.min(i,MAX_SCROLL_INDEX)
                  console.log("enter newIndex", newIndex);
                 setScrollIndex(newIndex)}}
                onLeave={(e) => {
                  let newindex = i + (e.currentPosition === 'below' ? -1 : 1)
                  console.log("leave newIndex", newindex);
                  setScrollIndex(Math.min(newindex,MAX_SCROLL_INDEX))
                }}
              >
                <div>{element}</div>
              </Waypoint>
              <Spacer style={{ minHeight: dbottom + 'px' }} />
            </React.Fragment>
          )
        })}
      </div>
    </StyledScroller>
  )
}

const Spacer = styled.div`
  /* pointer-events: none; */
`
const StyledScroller = styled.div`
  position: relative;
  display: block;
  z-index: 0;
  // fix for shaking while scrolling in safari
  transform: translateZ(0);
  backface-visibility: hidden;
  .back {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    z-index: 0;
    position: sticky;
    top: 0;
    /* height:100vh; */
  }
  .front {
    -webkit-transform: translate3d(0, 0, 100px);
    transform: translate3d(0, 0, 100px);
    position: relative;
    top: 0;
    /* z-index: 1001; */
    width: 100%;
  }
`
const Label = styled.div`
  position: sticky;
  z-index: 10100 !important;
  top: 10px;
  margin: 1em;
`
